import id_master_goods from "../../page/master/goods/language/id_master_goods"
import common from "./app/common_id"
import { id_goods } from "./app/master/goods"
import { id_groups } from "./app/master/group"

const main_id_language = {
	translation: {
		common,
		crop_img: { crop: "crop", ok: "potong gambar" },
		menu: {
			dashboard: "beranda",
			warehouse: "cek gudang",
			whstrans: "transaksi gudang",
			master: "pengaturan",
			sales: "penjualan",
			ecommerce: "toko online",
			ecommregister: "pendaftaran 1Toko",
			ecommlist: "daftar toko online",
			payment: "pembayaran",
			purchase: "pembelian",
			supplychain: "rantai pasokan",
			supplychain_point: "titik distribusi",
			supplychain_request: "permintaan barang",
			report: "laporan",
			rka: "Perencanaan & Anggaran",
			consignment: "konsinyasi",
			groups: 'kelompok barang',
		},
		login: {
			title: "Masuk Akun",
			password: "Kata Sandi",
			forgotpass: "Lupa Kata Sandi ?",
			submit: "Kirim",
		},
		dashboard: {
			search: { title: "cari perusahaan", placeholder: "ID Perusahaan" },
		},
		warehouse: {},
		whstrans: {},
		master_goods: id_master_goods,
		master: {
			convertionadd: "tambah konversi barang",
			convertionedit: "ubah konversi barang",
			finance: "keuangan",
			goods: id_goods,
			supplier: {
				add: "tambah pemasok",
				edit: "ubah pemasok",
			},
			sales: {
				add: "tambah sales",
				edit: "ubah sales",
			},
			customer: {
				add: "tambah pelanggan",
				edit: "ubah pelanggan",
			},
			courier: {
				add: "tambah kurir",
				edit: "ubah kurir",
			},
			groups: id_groups,
			profileadd: "tambah profil",
			profileedit: "ubah profil",
			process: {
				"": "proses",
				add: "tambah proses",
				edit: "ubah proses",
			},
			storage: {
				room: "ruang",
				add: "tambah ruang penyimpanan",
				edit: "ubah ruang penyimpanan",
				model: "model ruang penyimpanan",
			},
			bankacc: {
				bank: "bank",
				norek: "account number",
				namerek: "account name",
				add: "tambah rekening bank",
				edit: "ubah rekening bank",
			},
			payment_meth: {
				"": "metode pembayaran",
				time: "lama (hari)",
				add: "tambah metode pembayaran",
				edit: "ubah metode pembayaran",
			},
			po_fee: {
				other_costs: "biaya lainnya",
				local: "Lokal",
				import: "Impor",
			},
			tnc: {
				"": "kebijakan dan ketentuan",
			},
			user: {
				"": "pengguna",
				add: "tambah pengguna",
				edit: "ubah pengguna",
			},
			whs_setting: {
				"": "pengaturan gudang",
				add: "tambah gudang",
				edit: "ubah gudang",
			},
			brand: {
				// "": "brand",
				// "name": "nama brand",
				// add: "tambah brand",
				// edit: "tambah brand",
				"": "principal",
				"name": "nama principal",
				add: "tambah principal",
				edit: "ubah principal",
			}
		},
		mitra: {
			"": "permintaan barang",
			detail: "detail permintaan barang",
			additemreq: "tambah permintaan barang",
			edititemreq: "ubah permintaan barang",
		},
		spal: {
			addspal: "tambah kontrak",
			editspal: "ubah kontrak",
			addpaymentmethod: "tambah cara pembayaran ( kontrak )",
			editpaymentmethod: "ubah cara pembayaran ( kontrak )",
			addtime: "tambah waktu bongkar & muat ( kontrak )",
			edittime: "ubah waktu bongkar & muat ( kontrak )",
			adddemurrage: "tambah denda keterlambatan  ( kontrak )",
			editdemurrage: "ubah denda keterlambatan ( kontrak )",
			form: {
				paymentmethod: "cara pembayaran",
				demurrage: "denda keterlambatan",
				time: "waktu bongkar & muat",
			},
		},
		supplychain: {
			"": "rantai pasokan",
			add: "tambah titik distribusi",
			edit: "ubah titik distribusi",
			addgoodsreq: "tambah permintaan barang",
			editgoodsreq: "ubah permintaan barang",
			detailgoodsreq: "detail permintaan barang",
		},
		transaction: {
			common: {
				whs: "gudang penyimpanan",
				search_ref: "cari referensi",
				trans_id: "ID transaksi",
				add_item: "tambah barang",
			},
			convertion: {
				"": "konversi",
				add: "tambah konversi",
			},
			initstock: {
				"": "stok awal",
			},
			itemin: {
				"": "barang masuk",
			},
			iteminlist: {
				"": "supervisi barang masuk",
				detail: "detail barang masuk",
			},
			itemout: {
				"": "barang keluar",
			},
			itemoutlist: {
				"": "supervisi barang keluar",
				detail: "detail barang keluar",
			},
			itemstock: {
				"": "stok barang",
			},
			itemmove: {
				"": "perpindahan barang",
			},
			itemprocess: {
				"": "proses barang",
			},
			stockopname: {
				"": "stock opname",
				add: "tambah stock opname",
				edit: "ubah stock opname",
				detail: "detail stok opname",
			},
			returncuslist: {
				"": "supervisi retur pelanggan",
				"view": "detail retur pelanggan",
				"add": "tambah retur pelanggan ",
				"payment": "pembayaran retur pelanggan",
			},
			returnsuplist: {
				"": "supervisi retur pemasok",
			}
		},
		sales: {
			recap: {
				"": "rekap tagihan penjualan",
				add: "tambah rekap tagihan penjualan",
				detail: "detail rekap tagihan penjualan",
			},
			returncustomer: {
				"": "retur pelanggan",
				type: 'metode retur'
			},
		},
		purch: {
			recap: {
				"": "rekap tagihan pembelian",
				add: "tambah rekap tagihan pembelian",
				detail: "detail rekap tagihan pembelian",
			},
			returnsupplier: {
				"": "retur pemasok",
			},
			po: {
				"": "purchase order",
				create: "buat purchase order",
				edit: "ubah purchase order",
				create_mitra: "buat mitra purchase order",
				edit_mitra: "ubah mitra purchase order",
				currency: "mata uang",
				additional_cost: "tambahan biaya",
				additional_discount: "tambahan potongan",
				price_history: "riwayat harga",
				po_detail: "detail purchase order",
			},
		},
		payment: {
			debit: {
				add: "tambah piutang",
				detail: "detail piutang",
			},
			credit: {
				add: "tambah hutang",
				detail: "detail hutang",
			}
		},
		consignment: {
			"": "konsinyasi",
			detail: "detail konsinyasi",
			form: "input konsinyasi",
			add: "buat konsinyasi",
		},
		report: {},
		rka: {
			"": "Perencanaan & Anggaran",
			planning: {
				"": "perencanaan",
				add: "buat rencana",
				edit: "ubah rencana",
			},
		},
	},
}

export default main_id_language
